import { formatCents } from "../lib/crm";

/**
 * Montant tabulaire, en rouge s'il est négatif. `.crm-money` est en
 * `display: inline-block` : posée sur un <td>, elle sortirait la cellule du
 * tableau, d'où ce <span> à l'intérieur de la cellule.
 */
export function Money({
  cents,
  currency,
  strong,
}: {
  cents: number;
  currency?: string;
  strong?: boolean;
}) {
  const value = formatCents(cents, currency);
  return (
    <span className={cents < 0 ? "crm-money crm-money--neg" : "crm-money"}>
      {strong ? <strong>{value}</strong> : value}
    </span>
  );
}
